import React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from 'reactstrap';

const EventClosedAlert = () => {
  const { t } = useTranslation();
  return (
    <Alert color="success color-primary mt-3 mb-0" className="alert-additional" fade={false}>
      <div className="alert-body">
        <div className="d-flex">
          <div className="flex-shrink-0 me-3">
            <i className="ri-error-warning-line fs-16 align-middle"></i>
          </div>
          <div className="flex-grow-1">
            <h5 className="alert-heading">{t('Welcome')}!</h5>
            <p className="mb-0">{t('The event hasn\'t started yet')}.</p>
          </div>
        </div>
      </div>
      <div className="alert-content color-primary">
        <p className="mb-0">{t('Find out when the event starts and come back to see us')}!</p>
      </div>
    </Alert>
  );
};

export default EventClosedAlert;
